import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  public readonly baseUrl = environment.apiUrl;

  get apiUrl(): string {
    return this.baseUrl;
  }

  // Endpoints d'authentification (sans préfixe /api)
  get authEndpoints() {
    return {
      login: `${this.baseUrl}/auth/login`,
      register: `${this.baseUrl}/auth/register`,
      refresh: `${this.baseUrl}/auth/refresh`,
      profile: `${this.baseUrl}/auth/profile`,
      logout: `${this.baseUrl}/auth/logout`,
      forgotPassword: `${this.baseUrl}/auth/forgot-password`,
      resetPassword: `${this.baseUrl}/auth/reset-password`
    };
  }

  // Endpoints des convives
  get convivesEndpoints() {
    return {
      base: `${this.baseUrl}/convives`,
      byId: (id: string) => `${this.baseUrl}/convives/${id}`,
      byOrganization: (orgId: string) => `${this.baseUrl}/convives/organization/${orgId}`,
      stats: `${this.baseUrl}/convives/stats`
    };
  }

  // Endpoints des menus
  get menusEndpoints() {
    return {
      base: `${this.baseUrl}/menus`,
      byId: (id: string) => `${this.baseUrl}/menus/${id}`,
      byDate: (date: string) => `${this.baseUrl}/menus/date/${date}`,
      available: `${this.baseUrl}/menus/available`
    };
  }

  // Endpoints des commandes
  get commandesEndpoints() {
    return {
      base: `${this.baseUrl}/commandes`,
      byId: (id: string) => `${this.baseUrl}/commandes/${id}`,
      byConvive: (conviveId: string) => `${this.baseUrl}/commandes/convive/${conviveId}`,
      byDate: (date: string) => `${this.baseUrl}/commandes/date/${date}`,
      stats: `${this.baseUrl}/commandes/stats`,
      bulk: `${this.baseUrl}/commandes/bulk`
    };
  }

  // Endpoints des tournées
  get tourneesEndpoints() {
    return {
      base: `${this.baseUrl}/tournees`,
      byId: (id: string) => `${this.baseUrl}/tournees/${id}`,
      byDate: (date: string) => `${this.baseUrl}/tournees/date/${date}`,
      optimize: `${this.baseUrl}/tournees/optimize`,
      start: (id: string) => `${this.baseUrl}/tournees/${id}/start`,
      complete: (id: string) => `${this.baseUrl}/tournees/${id}/complete`
    };
  }

  // Endpoints des organisations
  get organizationsEndpoints() {
    return {
      base: `${this.baseUrl}/organizations`,
      byId: (id: string) => `${this.baseUrl}/organizations/${id}`,
      roles: `${this.baseUrl}/organizations/roles`
    };
  }

  // Endpoints de préfacturation
  get prefacturationEndpoints() {
    return {
      base: `${this.baseUrl}/prefacturation`,
      byId: (id: string) => `${this.baseUrl}/prefacturation/${id}`,
      byOrganization: (orgId: string) => `${this.baseUrl}/prefacturation/organization/${orgId}`,
      generate: `${this.baseUrl}/prefacturation/generate`,
      send: (id: string) => `${this.baseUrl}/prefacturation/${id}/send`,
      markPaid: (id: string) => `${this.baseUrl}/prefacturation/${id}/paid`
    };
  }

  // Endpoints d'export
  get exportEndpoints() {
    return {
      convives: `${this.baseUrl}/export/convives`,
      commandes: `${this.baseUrl}/export/commandes`,
      tournees: `${this.baseUrl}/export/tournees`,
      prefacturation: (id: string) => `${this.baseUrl}/export/prefacturation/${id}`
    };
  }

  // Endpoints du dashboard
  get dashboardEndpoints() {
    return {
      stats: `${this.baseUrl}/dashboard/stats`,
      recentActivity: `${this.baseUrl}/dashboard/recent-activity`
    };
  }
}
